<div class="reminders-modal-container">
  <div class="icon">
    <img
      src="/assets/images/night-sky-icon.png"
      alt="Image of a diamond encompassed by 4 smaller diamonds against a backdrop of a magenta to purple gradient"
      *ngIf="showInitialCase" />
    <svg-icon src="/assets/icons/reminder.svg" *ngIf="showNotNowCase"></svg-icon>
  </div>
  <div class="title" *ngIf="showInitialCase">Get the most out of your Purposeful experience with notifications.</div>
  <ng-container *ngIf="showInitialCase">
    <p class="description">
      Purposeful users who turn on notifications are much more likely to succeed in building positive habits and
      reaching their goals.
    </p>
    <p class="description incognito">
      Be aware that notifications will not work in browsers' incognito / private modes.
    </p>
  </ng-container>
  <ng-container *ngIf="showNotNowCase">
    <p class="description">You can enable push notifications under 'Reminders' if you change your mind.</p>
  </ng-container>
  <div class="button-row" *ngIf="showInitialCase">
    <button class="button button-pill button-reverse disable" (click)="notNow()">Not now</button>
    <button class="button button-pill button-reverse enable" (click)="enable()">Turn on</button>
  </div>
  <div class="button-row" *ngIf="showNotNowCase">
    <button class="button button-pill button-reverse enable" (click)="dismissModal()">Got it</button>
  </div>
</div>
